import React from "react";
import fieldPropTypes from "./field-prop-types";

class ExpandoField extends React.Component {
  constructor(props) {
    super(props);
    const { appData } = props;
    this.handleCheckboxReturnArrayClick =
      appData.handleCheckboxReturnArrayClick;
  }

  handleCheckboxClickWrapper = (value, title) => {
    const { field } = this.props;
    const option = field.options.find(optionItem => optionItem.value === value);
    option.selected = !option.selected;
    field.optionsData
      .find(data => data.filter_header === title)
      .filter_options.find(
        optionItem => optionItem.cell_data.value === value
      ).selected = option.selected;

    this.handleCheckboxReturnArrayClick(field);
  };

  drawExpandos = (options, ExandoOption) => {
    const { settings } = this.props.appData;

    return options.map(option => {
      return (
        <ExandoOption
          onCheckboxChange={this.handleCheckboxClickWrapper}
          title={option.filter_header}
          options={option.filter_options}
          key={option.filter_header}
          settings={settings}
        />
      );
    });
  };

  render() {
    const {
      field: { optionsData },
      components: { ExpandoOption }
    } = this.props;

    return (
      <div className='expando-field-wrapper-web-sdk'>
        {this.drawExpandos(optionsData, ExpandoOption)}
      </div>
    );
  }
}

ExpandoField.propTypes = fieldPropTypes;

export default ExpandoField;
